import React, { useEffect, useMemo, useState } from "react";
// import { Form } from '@ant-design/compatible';

// import '@ant-design/compatible/assets/index.css';


import { Modal, Button } from "antd";
import moment from "moment";
import {
  Row,
  Col,
  Card,
  Checkbox,
  Input,
  Select,
  Skeleton,
  Typography,
  Radio,
  Tag,
  Collapse,
  Spin,
} from 'antd';
import HttpRequest from "../../../../utils/HttpRequest";
import { GeneInfo } from '../GenaScreen/ResultFound/ResultFound'
import './CaseHistory.css'
import { useHistory } from 'react-router-dom';
import SymptomsQueryTags from "../GenaScreen/SymptomsQueryTags/SymptomsQueryTags";
import { Divider } from "rc-menu";
import CustomIcon from "../../../../utils/components/CustomIcon/CustomIcon";
import { CaretRightOutlined } from "@ant-design/icons";

const { Title } = Typography
const { Panel } = Collapse;

const customPanelStyle = {
  background: '#f7f7f7',
  borderRadius: 8,
  marginBottom: 24,
  border: 0,
  overflow: 'hidden',
};

const TagsComponent = ({ title, caseVersion }) => {
  if (caseVersion === null) return null

  const { queryJSON, ethnicity, age, gender } = caseVersion.SearchHistory || {}

  return (
    <div className="flex-vertical-gap-2">
      <Typography.Text type="secondary">Saved: {moment(caseVersion.createdAt).local().format('DD/MM/YYYY HH:mm:ss')}</Typography.Text>
      <Title level={3} style={{ margin: 0 }}>{title}</Title>
      <div className="custom-tag-container">
        <Tag className="custom-tag">{ethnicity}</Tag>
        <Tag className="custom-tag">{age}</Tag>
        <Tag className="custom-tag">{gender}</Tag>
      </div>
      <SymptomsQueryTags node={queryJSON} />
    </div>
  )
}

const CaseHistoryComponent = ({ title, caseVersion }) => {
  const history = useHistory()
  const [genes, setGenes] = useState(null)
  const [totalGenes, setTotalGenes] = useState(0)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    if (!caseVersion) return

    setLoading(true)
    setGenes(null)
    setTotalGenes(0)
    // Fetch data from master case for the time being
    const fetchData = async () => {
      try {
        const caseVersionId = caseVersion.id
        const { query, geneFilter, clinicalFeatures } = caseVersion.SearchHistory || {}

        let queryString = '?caseVersionId=' + caseVersionId

        if (geneFilter === 'withDisorders') {
          queryString += "&withDisorders=true"
        } else if (geneFilter === 'dominant') {
          queryString += "&dominant=true"
        } else if (geneFilter === 'recessive') {
          queryString += "&recessive=true"
        } else if (geneFilter === 'x-linked') {
          queryString += "&x-linked=true"
        } else {
          queryString += "&withDisorders=true"
        }

        if (clinicalFeatures)
          queryString += "&clinicalFeatureSearchStr=" + clinicalFeatures;

        queryString += "&hpoQueryStr=" + query;
        queryString += "&start=" + 0;
        queryString += "&rows=" + 100000;

        const res = await new HttpRequest(null, `/genes${queryString}`, 'get', {})
          .send()
        const { docs, numFound } = res.data.data.response
        setGenes(docs)
        setTotalGenes(numFound)
      } catch (error) {
      } finally {
        setLoading(false)
      }
    };
    fetchData()
  }, [caseVersion])

  const handleResumeSearch = () => {
    const id = caseVersion.SearchHistory.id
    // navigate to screen home page
    history.push(`/search?searchRecordId=${id}`)
  }

  return (
    <div className="flex-vertical-gap-4">
      {/* {<TagsComponent title={title} caseVersion={caseVersion} />} */}
      <div className="flex-vertical-gap-2">
        <Button style={{ background: 'transparent' }} block onClick={handleResumeSearch}>
          Resume Search
          <CustomIcon name="Search" />
        </Button>
      </div>
      {loading ? <Skeleton /> : (Array.isArray(genes) && <GeneInfo total={totalGenes} genes={genes} />)}
    </div>
  )
};

const CaseHistoryModal = ({ isModalOpen, setIsModalOpen, caseDetails }) => {
  const handleCancel = () => {
    setIsModalOpen(false); // Close modal
  };

  return (
    (<Modal
      title={
        <div className="flex-vertical-gap-4">
          <div className="flex-horizontal-gap-4">
            <CustomIcon name="History" width={40} height={40} />
            <Typography.Title level={2} style={{ margin: 0 }}>Case History</Typography.Title>
          </div>
          <Button type="default" block onClick={handleCancel}>
            Back To Details
            <CustomIcon name="Undo" />
          </Button>
        </div>
      }
      open={isModalOpen}
      onCancel={handleCancel}
      footer={null}
      width={800}
      bodyStyle={{
        maxHeight: '60vh',
        overflowY: 'auto'
      }}
    >
      <Collapse
        style={{ background: 'transparent' }}
        bordered={false}
        defaultActiveKey={[1]}
        expandIcon={({ isActive }) => <CaretRightOutlined style={{ transform: `rotate(${isActive ? 90 : 0}deg)` }} />}
      >
        {
          caseDetails.CaseVersions.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)).map((caseVersion, index) => {
            return(
              <Panel header={<TagsComponent title={caseDetails.nickName} caseVersion={caseVersion} />} key={index + 1} style={customPanelStyle}>
                <CaseHistoryComponent title={caseDetails.nickName} caseVersion={caseVersion} />
              </Panel>
            )
          })
        }
      </Collapse>
    </Modal>)
  );
}

export default CaseHistoryModal;
  
